// Utility helpers for the 1Rupee Clinic Membership prototype.
// Note: All data is stored locally in browser localStorage (prototype only).

export const MEMBERSHIP_PRICE = 100; // INR — single source of truth for card price

const STORAGE_KEY = "magicdil_members";

export const formatMobile = (m) => {
  const digits = (m || "").replace(/\D/g, "").slice(0, 10);
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)} ${digits.slice(5, 10)}`;
};

export const maskMobile = (m) => {
  const digits = (m || "").replace(/\D/g, "");
  if (digits.length !== 10) return m;
  return `+91 ${digits.slice(0, 2)}${"X".repeat(5)}${digits.slice(7)}`;
};

export const generateMembershipNumber = () => {
  const year = new Date().getFullYear().toString().slice(-2);
  const alpha = "ABCDEFGHJKLMNPQRSTUVWXYZ";
  const digits = "0123456789";
  const a = Array.from({ length: 2 }, () => alpha[Math.floor(Math.random() * alpha.length)]).join("");
  const d = Array.from({ length: 6 }, () => digits[Math.floor(Math.random() * digits.length)]).join("");
  return `MD${year}-${a}${d}`;
};

export const getValidityRange = () => {
  const now = new Date();
  const expiry = new Date(now);
  expiry.setFullYear(now.getFullYear() + 1);
  const fmt = (d) =>
    d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  return { issued: fmt(now), expires: fmt(expiry), issuedRaw: now, expiresRaw: expiry };
};

export const saveMember = (member) => {
  try {
    const all = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    all.unshift(member);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all.slice(0, 50)));
  } catch (e) {
    // ignore
  }
};

export const getAllMembers = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  } catch (e) {
    return [];
  }
};

export const findMemberByNumber = (num) => {
  return getAllMembers().find(
    (m) => m.membershipNumber.toLowerCase() === (num || "").toLowerCase()
  );
};

export const validateName = (n) => /^[A-Za-z\s.'-]{2,50}$/.test((n || "").trim());
export const validateMobile = (m) => /^[6-9]\d{9}$/.test((m || "").replace(/\D/g, ""));
